"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesDetail = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const site_kpi_1 = require("client/modules/sites/modules/sites-detail/components/site-kpi");
const store_1 = require("client/modules/users/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
require("./sites-detail.less");
const store_2 = require("./store");
const contacts_1 = require("./tabs/contacts");
const details_1 = require("./tabs/details");
const distributors_1 = require("./tabs/distributors");
const financial_1 = require("./tabs/financial");
// import { InventoryStockTab } from "./tabs/inventory-stock";
const orders_1 = require("./tabs/orders");
const pads_1 = require("./tabs/pads");
const patients_1 = require("./tabs/patients");
const providers_1 = require("./tabs/providers");
const settings_1 = require("./tabs/settings");
const users_1 = require("./tabs/users");
let SitesDetail = class SitesDetail extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.withPadding = true;
        this.addTab("Details", () => `/pharmacies/${Number(this.props.params[0])}`, /^\/pharmacies\/(\d+)$/, details_1.DetailsTab);
        {
            store_1.usersStore.permissions.ReadClaims &&
                this.addTab("Claims", () => `/pharmacies/${Number(this.props.params[0])}/claims`, /^\/pharmacies\/(\d+)\/claims$/, orders_1.OrdersTab);
        }
        {
            store_1.usersStore.permissions.ReadUser &&
                this.addTab("Users", () => `/pharmacies/${Number(this.props.params[0])}/users`, /^\/pharmacies\/(\d+)\/users\/?(\d+)?$/, users_1.UsersTab);
        }
        {
            store_1.usersStore.permissions.ReadProvider &&
                this.addTab("Providers", () => `/pharmacies/${Number(this.props.params[0])}/providers`, /^\/pharmacies\/(\d+)\/providers\/?(\d+)?$/, providers_1.ProvidersTab);
        }
        {
            store_1.usersStore.permissions.ReadPatient &&
                this.addTab("Patients", () => `/pharmacies/${Number(this.props.params[0])}/patients`, /^\/pharmacies\/(\d+)\/patients$/, patients_1.PatientsTab);
        }
        {
            store_1.usersStore.permissions.ReadPads &&
                this.addTab("Pads", () => `/pharmacies/${Number(this.props.params[0])}/pads`, /^\/pharmacies\/(\d+)\/pads$/, pads_1.PadsTab);
        }
        {
            store_1.usersStore.permissions.UpdatePharmacy &&
                this.addTab("Settings", () => `/pharmacies/${Number(this.props.params[0])}/settings`, /^\/pharmacies\/(\d+)\/settings$/, settings_1.SettingsTab);
        }
        {
            store_1.usersStore.permissions.ManageSiteFinancial && store_1.usersStore.permissions.UpdatePharmacy &&
                this.addTab("Financial", () => `/pharmacies/${Number(this.props.params[0])}/financial`, /^\/pharmacies\/(\d+)\/financial$/, financial_1.FinancialTab, () => { var _a; return !!((_a = store_2.sitesDetailStore.site.value) === null || _a === void 0 ? void 0 : _a.allowSiteCopayCollection); });
        }
        {
            store_1.usersStore.permissions.ReadDistributors &&
                this.addTab("Distributors", () => `/pharmacies/${Number(this.props.params[0])}/distributors`, /^\/pharmacies\/(\d+)\/distributors$/, distributors_1.DistributorsTab);
        }
        {
            store_1.usersStore.permissions.ReadDistributors &&
                this.addTab("Contacts", () => `/pharmacies/${Number(this.props.params[0])}/contacts`, /^\/pharmacies\/(\d+)\/contacts\/?(\d+)?$/, contacts_1.ContactsTab);
        }
    }
    async componentDidMount() {
        const siteId = Number(this.props.params[0]);
        /** Not sure why we're loading all this at once, is it in case of
         * a user switching sites with the top bar? Can we just set siteDetailsStore
         * to null on unmount?
         */
        if (siteId) {
            await store_2.sitesDetailStore.loadUsers({ allSites: true, id: siteId });
            await store_2.sitesDetailStore.loadOrders(siteId);
            await store_2.sitesDetailStore.loadPads({ id: siteId });
            await store_2.sitesDetailStore.loadPatients({ id: siteId });
            await store_2.sitesDetailStore.loadProviders({ id: siteId });
            await store_2.sitesDetailStore.loadEditPatients({ id: siteId });
            await store_2.sitesDetailStore.loadEditProviders({ id: siteId });
            await store_2.sitesDetailStore.readSite(siteId);
            this.showTabs(true);
        }
        else {
            this.showTabs(false);
        }
    }
    async componentWillReceiveProps(props) {
        const oldSiteId = Number(this.props.params[0]);
        const newSiteId = Number(props.params[0]);
        if (newSiteId && oldSiteId !== newSiteId) {
            await store_2.sitesDetailStore.loadUsers({ allSites: true, id: newSiteId });
            await store_2.sitesDetailStore.loadOrders(newSiteId);
            await store_2.sitesDetailStore.loadPatients({ id: newSiteId });
            await store_2.sitesDetailStore.loadProviders({ id: newSiteId });
            await store_2.sitesDetailStore.loadEditPatients({ id: newSiteId });
            await store_2.sitesDetailStore.loadEditProviders({ id: newSiteId });
            await store_2.sitesDetailStore.readSite(newSiteId);
        }
        if (newSiteId) {
            this.showTabs(true);
        }
        else {
            this.showTabs(false);
        }
    }
    render() {
        var _a, _b, _c, _d;
        const siteId = Number(this.props.params[0]);
        const newSiteClass = siteId === 0 ? "new-site-" : "";
        const site = store_2.sitesDetailStore.site.value;
        return (React.createElement("div", { className: "sites" }, (store_1.usersStore.permissions.CreatePharmacy && !siteId) || // If we can create.
            store_1.usersStore.permissions.ReadPharmacies || // If we can view any.
            (store_1.usersStore.permissions.ReadPharmacy) ? ( // If we can view ours.  && usersStore.user.value.site.id === siteId //B-063.11 2024-07-11 19:33:37
        React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "sites__title-wrapper--detail" },
                    React.createElement(site_kpi_1.SiteKpi, { siteKpi: {
                            approved: 1200,
                            city: capitalize_string_1.capitalizeString((_a = site === null || site === void 0 ? void 0 : site.city) !== null && _a !== void 0 ? _a : ""),
                            dispensed: 1200,
                            name: siteId === 0
                                ? "New Pharmacy"
                                : (site &&
                                    `NCPDP: ${site.ncpdpId} | ${capitalize_string_1.capitalizeString(site.displayName || site.name)}`) ||
                                    "",
                            npi: (_b = site === null || site === void 0 ? void 0 : site.npiNumber) !== null && _b !== void 0 ? _b : "",
                            phone: (_c = site === null || site === void 0 ? void 0 : site.phone) !== null && _c !== void 0 ? _c : "",
                            state: (_d = site === null || site === void 0 ? void 0 : site.state) !== null && _d !== void 0 ? _d : ""
                        } }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: `sites__${newSiteClass}tabs cstm-fixed_header-nav` }, super.render())))) : (store_1.usersStore.showLock())));
    }
};
SitesDetail = __decorate([
    mobx_react_1.observer
], SitesDetail);
exports.SitesDetail = SitesDetail;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/sites-detail.tsx
// module id = 4005
// module chunks = 0